import React, { Fragment, useState } from 'react';
import { ChangeEventHandler } from 'react';
import { Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { RootState } from '../../presentation/redux/store/RootState';
import { useDispatch, useSelector } from 'react-redux';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import Table from 'react-bootstrap/Table';
import { saveHorarios } from '../action/saveHorarios';
import { TableRowHorarios } from './TableRowHorarios';
import '../../styles/tabla-pines-horas.css';


interface ModalProps {
    isOpen: boolean;
    toggle: Function;
    token: string;
    usuario: string;
}

const initialState = {
    lun_hf: "",
    lun_hi: "",
    mar_hf: "",
    mar_hi: "",
    mie_hf: "",
    mie_hi: "",
    jue_hf: "",
    jue_hi: "",
    vie_hf: "",
    vie_hi: "",
    sab_hf: "",
    sab_hi: "",
    dom_hf: "",
    dom_hi: "",
    com_hf: "",
    com_hi: ""
}

export const ModalHorarios: React.FC<ModalProps> = (props: ModalProps) => {
    const dispatch = useDispatch();
    const moment = require('moment');
    const { isOpen, toggle, token, usuario } = props;
    const pinesHorarios = useSelector((s: RootState) => s.pinesState.pinesHorarios);
    const [formValues, setFormValues] = useState(initialState);
    const [isEditing, setIsEditing] = useState(false);

    const { com_hf, com_hi, dom_hf, dom_hi, jue_hf,
        jue_hi, lun_hf, lun_hi, mar_hf, mar_hi, mie_hf, mie_hi,
        sab_hf, sab_hi, vie_hf, vie_hi } = formValues;

    const editHorarios = () => {
        const values = {
            lun_hf: hourFormat(pinesHorarios.lun_hf),
            lun_hi: hourFormat(pinesHorarios.lun_hi),
            mar_hf: hourFormat(pinesHorarios.mar_hf),
            mar_hi: hourFormat(pinesHorarios.mar_hi),
            mie_hf: hourFormat(pinesHorarios.mie_hf),
            mie_hi: hourFormat(pinesHorarios.mie_hi),
            jue_hf: hourFormat(pinesHorarios.jue_hf),
            jue_hi: hourFormat(pinesHorarios.jue_hi),
            vie_hf: hourFormat(pinesHorarios.vie_hf),
            vie_hi: hourFormat(pinesHorarios.vie_hi),
            sab_hf: hourFormat(pinesHorarios.sab_hf),
            sab_hi: hourFormat(pinesHorarios.sab_hi),
            dom_hf: hourFormat(pinesHorarios.dom_hf),
            dom_hi: hourFormat(pinesHorarios.dom_hi),
            com_hf: hourFormat(pinesHorarios.com_hf),
            com_hi: hourFormat(pinesHorarios.com_hi)
        }
        setFormValues(values);
        setIsEditing(true);
    };


    const handleInputChange: ChangeEventHandler<HTMLInputElement> = ({ currentTarget }) => {
        setFormValues({
            ...formValues,
            [currentTarget.name]: currentTarget.value
        });
    }

    const hourFormat = (value: any) => {
        if (value) {
            return moment(value, 'HH:mm').format('HH:mm');
        } else {
            return moment('0000', 'HH:mm').format('HH:mm');
        }
    }

    const guardarHorarios = (e: any) => {
        e.preventDefault();
        if (isValid()) {
            dispatch(UIActions.uiLoadActive());
            saveHorarios(token, formValues, dispatch, usuario);
            toggle();
            setFormValues(initialState);
            setIsEditing(false);
        }
    }

    const isValid = () => {
        if (!com_hf || !com_hi || !dom_hf || !dom_hi || !jue_hf ||
            !jue_hi || !lun_hf || !lun_hi || !mar_hf || !mar_hi ||
            !mie_hf || !mie_hi || !sab_hf || !sab_hi || !vie_hf || !vie_hi) {
            Swal.fire('Advertencia', 'Los campos de los horarios deben ir completos', 'warning');
            return false;
        } else if (com_hf <= com_hi || dom_hf <= dom_hi || jue_hf <= jue_hi ||
            lun_hf <= lun_hi || mar_hf <= mar_hi || mie_hf <= mie_hi ||
            sab_hf <= sab_hi || vie_hf <= vie_hi) {
            Swal.fire('Advertencia', 'Favor de verificar que la hora fin no sea menor o igual a la hora inicio', 'warning');
            return false;
        }
        return true
    }

    const cancelarEdit = () => {
        toggle();
        setIsEditing(false);
    }

    return (
        <Modal
            onHide={cancelarEdit}
            show={isOpen}
            backdrop="static"
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton className='gradientBlue colorWhite'>
                <Modal.Title id="contained-modal-title-vcenter">
                    Horarios Pin Usuario {usuario}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='p-2 bg-light'>
                <div className="p-1 mb-1 text-dark"><small>{
                    (!isEditing) ? <>Para editar los horarios del Pin Usuario {usuario} da clic en el botón "Editar".</> :
                        <>Para establecer el horario del Pin Usuario {usuario} selecciona las horas de inicio y fin por cada día de la semana y comida, al finalizar da clic en el botón "Guardar".</>
                }</small></div>
                <div className='table-responsive resp pinesTable'>
                    <Table hover responsive className="table resp table-striped">
                        <thead>
                            <tr><th style={{ width: '1%' }}>Día</th>
                                <th style={{ width: '1%' }}>Lunes</th>
                                <th style={{ width: '1%' }}>Martes</th>
                                <th style={{ width: '1%' }}>Miércoles</th>
                                <th style={{ width: '1%' }}>Jueves</th>
                                <th style={{ width: '1%' }}>Viernes</th>
                                <th style={{ width: '1%' }}>Sábado</th>
                                <th style={{ width: '1%' }}>Domingo</th>
                                <th style={{ width: '1%' }}>Comida</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                <Fragment>
                                    {
                                        (isEditing) ? (
                                            <>
                                                <tr className='tablaPinesHoras'>
                                                    <td>
                                                        <span>Hora inicio</span>
                                                    </td>
                                                    {/*    {[lun_hi, mar_hi, mie_hi, jue_hi, vie_hi, sab_hi, dom_hi, com_hi].map((placement) => (
                                                        <td>
                                                            <Form.Control
                                                                key={placement}
                                                                onChange={handleInputChange}
                                                                defaultValue={hourFormat(placement) || ''}
                                                                id={placement}
                                                                name={placement}
                                                                type="time"
                                                                autoComplete='off'
                                                            >
                                                            </Form.Control>
                                                        </td>
                                                    ))} */}
                                                    <td>
                                                        <Form.Control
                                                            onChange={handleInputChange}
                                                            defaultValue={hourFormat(lun_hi) || ''}
                                                            id="lun_hi"
                                                            name="lun_hi"
                                                            type="time"
                                                            autoComplete='off'
                                                        >
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            onChange={handleInputChange}
                                                            defaultValue={hourFormat(mar_hi) || ''}
                                                            id="mar_hi"
                                                            name="mar_hi"
                                                            type="time"
                                                            autoComplete='off'
                                                        >
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            onChange={handleInputChange}
                                                            defaultValue={hourFormat(mie_hi) || ''}
                                                            id="mie_hi"
                                                            name="mie_hi"
                                                            type="time"
                                                            autoComplete='off'
                                                        >
                                                        </Form.Control>
                                                    </td>
                                                    <td><Form.Control
                                                        onChange={handleInputChange}
                                                        defaultValue={hourFormat(jue_hi) || ''}
                                                        id="jue_hi"
                                                        name="jue_hi"
                                                        type="time"
                                                        autoComplete='off'
                                                    >
                                                    </Form.Control>
                                                    </td>
                                                    <td><Form.Control
                                                        onChange={handleInputChange}
                                                        defaultValue={hourFormat(vie_hi) || ''}
                                                        id="vie_hi"
                                                        name="vie_hi"
                                                        type="time"
                                                        autoComplete='off'
                                                    >
                                                    </Form.Control>
                                                    </td>
                                                    <td><Form.Control
                                                        onChange={handleInputChange}
                                                        defaultValue={hourFormat(sab_hi) || ''}
                                                        id="sab_hi"
                                                        name="sab_hi"
                                                        type="time"
                                                        autoComplete='off'
                                                    >
                                                    </Form.Control>
                                                    </td>
                                                    <td> <Form.Control
                                                        onChange={handleInputChange}
                                                        defaultValue={hourFormat(dom_hi) || ''}
                                                        id="dom_hi"
                                                        name="dom_hi"
                                                        type="time"
                                                        autoComplete='off'
                                                    >
                                                    </Form.Control>
                                                    </td>
                                                    <td> <Form.Control
                                                        onChange={handleInputChange}
                                                        defaultValue={hourFormat(com_hi) || ''}
                                                        id="com_hi"
                                                        name="com_hi"
                                                        type="time"
                                                        autoComplete='off'
                                                    >
                                                    </Form.Control>
                                                    </td>
                                                </tr>
                                                <tr className='tablaPinesHoras'>
                                                    <td>
                                                        <span>Hora fin</span>
                                                    </td>
                                                    {/*     {[lun_hf, mar_hf, mie_hf, jue_hf, vie_hf, sab_hf, dom_hf, com_hf].map((currentValue, index, thisArg) => (
                                                        <td>
                                                            <Form.Control
                                                                key={varToString({ currentValue })}
                                                                onChange={handleInputChange}
                                                                defaultValue={hourFormat(currentValue) || ''}
                                                                id={varToString({ currentValue })}
                                                                name={currentValue}
                                                                type="time"
                                                                autoComplete='off'
                                                            >
                                                            </Form.Control>
                                                        </td>
                                                    ))} */}
                                                    <td>
                                                        <Form.Control
                                                            onChange={handleInputChange}
                                                            defaultValue={hourFormat(lun_hf) || ''}
                                                            id="lun_hf"
                                                            name="lun_hf"
                                                            type="time"
                                                            autoComplete='off'
                                                        >
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            onChange={handleInputChange}
                                                            defaultValue={hourFormat(mar_hf) || ''}
                                                            id="mar_hf"
                                                            name="mar_hf"
                                                            type="time"
                                                            autoComplete='off'
                                                        >
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            onChange={handleInputChange}
                                                            defaultValue={hourFormat(mie_hf) || ''}
                                                            id="mie_hf"
                                                            name="mie_hf"
                                                            type="time"
                                                            autoComplete='off'
                                                        >
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            onChange={handleInputChange}
                                                            defaultValue={hourFormat(jue_hf) || ''}
                                                            id="jue_hf"
                                                            name="jue_hf"
                                                            type="time"
                                                            autoComplete='off'
                                                        >
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            onChange={handleInputChange}
                                                            defaultValue={hourFormat(vie_hf) || ''}
                                                            id="vie_hf"
                                                            name="vie_hf"
                                                            type="time"
                                                            autoComplete='off'
                                                        >
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            onChange={handleInputChange}
                                                            defaultValue={hourFormat(sab_hf) || ''}
                                                            id="sab_hf"
                                                            name="sab_hf"
                                                            type="time"
                                                            autoComplete='off'
                                                        >
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            onChange={handleInputChange}
                                                            defaultValue={hourFormat(dom_hf) || ''}
                                                            id="dom_hf"
                                                            name="dom_hf"
                                                            type="time"
                                                            autoComplete='off'
                                                        >
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            onChange={handleInputChange}
                                                            defaultValue={hourFormat(com_hf) || ''}
                                                            id="com_hf"
                                                            name="com_hf"
                                                            type="time"
                                                            autoComplete='off'
                                                        >
                                                        </Form.Control>
                                                    </td>
                                                </tr>
                                            </>
                                        ) : (
                                            <TableRowHorarios
                                                pinesHorarios={pinesHorarios}
                                            />
                                        )
                                    }
                                </Fragment>
                            }
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer className='bg-light'>
                <button onClick={cancelarEdit} className="btn btn-light btn-outline-secondary float-right">Cancelar</button>
                {(isEditing) ? (
                    <button onClick={guardarHorarios} className="btn btn-primary float-right" type="submit">Guardar</button>
                ) : (
                    <button onClick={editHorarios} className="btn btn-primary float-right" type="submit">Editar</button>
                )
                }
            </Modal.Footer>
        </Modal >
    )
}